import { useState } from 'react'
import { useFormActions, useFormData } from '@hooks/useFormStore'
import type { TipoCliente } from '@/types'
import styles from './TipoClienteSection.module.css'

export function TipoClienteSection() {
  const formData = useFormData()
  const { setData, nextStep } = useFormActions()
  const [selected, setSelected] = useState<TipoCliente>(formData.tipo_cliente || 'domestico')

  const handleSelect = (tipo: TipoCliente) => {
    setSelected(tipo)
    setData({ tipo_cliente: tipo })
  }

  const handleContinue = () => {
    setData({ tipo_cliente: selected })
    nextStep()
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionIcon}>
          <i className="bi bi-people-fill" />
        </div>
        <div>
          <h2 className={styles.sectionTitle}>Tipo di Cliente</h2>
          <p className={styles.sectionDescription}>Seleziona la tipologia di utenza per la tua fornitura</p>
        </div>
      </div>

      <div className={styles.cards}>
        <button
          type="button"
          className={`${styles.card} ${styles.cardDomestico} ${selected === 'domestico' ? styles.cardSelected : ''}`}
          onClick={() => handleSelect('domestico')}
        >
          <div className={styles.cardCheck}><i className="bi bi-check2" /></div>
          <div className={styles.cardIconWrapper}>
            <i className="bi bi-house-door-fill" />
          </div>
          <h3 className={styles.cardTitle}>Domestico</h3>
          <p className={styles.cardDescription}>
            Per abitazioni private, uso residenziale e familiare
          </p>
        </button>

        <button
          type="button"
          className={`${styles.card} ${styles.cardBusiness} ${selected === 'business' ? styles.cardSelected : ''}`}
          onClick={() => handleSelect('business')}
        >
          <div className={styles.cardCheck}><i className="bi bi-check2" /></div>
          <div className={styles.cardIconWrapper}>
            <i className="bi bi-building-fill" />
          </div>
          <h3 className={styles.cardTitle}>Business</h3>
          <p className={styles.cardDescription}>
            Per aziende, partite IVA e attivit&agrave; commerciali
          </p>
        </button>
      </div>

      <button type="button" className={styles.continueBtn} onClick={handleContinue}>
        Continua <i className="bi bi-arrow-right" />
      </button>
    </div>
  )
}
